var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcons8AroundTheGlobe2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9072 20.1217L17.9792 19.0497L16.7344 11.1521L20.328 7.5585C20.96 6.9265 20.96 5.9041 20.328 5.2721C19.696 4.6401 18.6736 4.6401 18.0416 5.2721L14.448 8.8657L6.55039 7.6193L5.47839 8.6913L11.2976 12.0161L8.52319 14.7905L5.62559 14.0657L4.79999 14.8913L10.7088 20.8001L11.5344 19.9745L10.8096 17.0769L13.5824 14.3041L16.9072 20.1217Z",
    fill: "#FFD708"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 4.80005C23.9008 4.80005 23.8064 4.81285 23.7088 4.81445C24.0736 5.84965 24.0736 6.97925 23.7104 8.01445C23.8064 8.01285 23.9024 8.00005 24 8.00005C27.368 8.00005 30.4912 9.05125 33.072 10.8352L32 11.2V12.8H30.4L28.8 14.4V17.6L32 16L36.8 17.6L35.2 20.8L32 19.2H28.8L25.6 22.4V25.6L28.8 28.8H32L33.6 32L30.232 38.736C28.3152 39.5488 26.2096 40 24 40C23.4112 40 22.832 39.9632 22.2608 39.9008L19.144 36.8576L19.2 30.4L14.4 25.6H9.59999L8.38719 27.4608C8.14079 26.344 7.99999 25.1888 7.99999 24C7.99999 23.5552 8.03039 23.1184 8.06719 22.6832L5.25919 19.8752C4.96479 21.2048 4.79999 22.5824 4.79999 24C4.79999 34.5872 13.4128 43.2 24 43.2C34.5872 43.2 43.2 34.5872 43.2 24C43.2 13.4128 34.5872 4.80005 24 4.80005Z",
    fill: "#22428F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8AroundTheGlobe2);
export default __webpack_public_path__ + "static/media/icons8-around-the-globe 2.6f245d39fb80ee13688f5042b7405c44.svg";
export { ForwardRef as ReactComponent };